import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

import { useIsAuthenticated } from "@azure/msal-react";
import SignIn from "./pages/login/login";
import { useSelector } from "react-redux";
import { useCheckUserRoles } from "./utils";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RAG from "./pages/chat/RAG";

import theme from "./style/theme";
import History from "./pages/History";
import { useEffect } from "react";
import { RootState } from "./store/AriStore";
import FileTree from "./pages/admin/FileTree";
import DocumentManager from "./pages/admin/DocumentManager";
import UsageDashboard from "./pages/admin/UsageDashboard";
import AlertDialog from "./components/AlertDialog";

export default function JoyMessagesTemplate() {
  const isAuthenticated = useIsAuthenticated();
  const userInfo = useSelector((state: any) => state.user);
  const isGlobalLoading = useSelector((state: RootState) => state.loading.requestsInFlight > 0);
  var res = useCheckUserRoles(isAuthenticated ? sessionStorage.getItem("idToken") : null);

  useEffect(() => {
    if (!isAuthenticated) {
      sessionStorage.clear();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    // 현재 URL에 /redirct가 포함되어 있으면 도메인 루트로 이동
    if (window.location.pathname.includes('/redirct')) {
      window.location.href = '/';
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!isAuthenticated || userInfo.role === "Not Authorized" || userInfo.role === null ? (
        <Box sx={{ display: "flex", minHeight: "100dvh", minWidth: "100dvw", justifyContent: "center" }}>
          <SignIn role={userInfo.role}/>
        </Box>
      ) : (
        <Box sx={{ display: "flex", minHeight: "100dvh", minWidth: "100dvw" }}>
          <BrowserRouter>
              <Routes>
                <Route path="/" element={<RAG />} />
                <Route path='/history' element={<History />} />
                <Route path='/console/file-tree' element={<FileTree />} />
                <Route path='/console/document-manager' element={<DocumentManager />} />
                <Route path='/console/usage' element={<UsageDashboard />} />
              </Routes>
          </BrowserRouter>
          <AlertDialog />
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isGlobalLoading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </Box>
      )}
    </ThemeProvider>
  );
}
